import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

/**
 * Acumulação & Distribuição de Chaikin (FML.AD) — painel próprio, 2 linhas:
 * AD (linha acumulada) e M (sua média móvel). yAccessor(d) retorna { ad, m }.
 */
class AccumDistSeries extends Component {
  constructor(props) {
    super(props);
    this.adAccessor = this.adAccessor.bind(this);
    this.mAccessor = this.mAccessor.bind(this);
  }
  adAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.ad;
  }
  mAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.m;
  }
  render() {
    const { strokeAd, strokeM, className } = this.props;
    return (
      <g className={className}>
        <LineSeries yAccessor={this.adAccessor} stroke={strokeAd} fill="none" />
        <LineSeries yAccessor={this.mAccessor} stroke={strokeM} fill="none" />
      </g>
    );
  }
}

AccumDistSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  strokeAd: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeM: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

AccumDistSeries.defaultProps = {
  strokeAd: { color: "#FFFF00" },
  strokeM: { color: "#FF0000" },
  className: "react-stockcharts-accumdist-series",
};

export default AccumDistSeries;
